import React, { useState } from 'react'
import { getImages } from '../../Common/const'
import { motion } from "framer-motion";
import UseScrollReveal from '../../Common/UseScrollReveal';
import BookAppointmentModal from './BookAppointmentModal';
import ModalLayout from '../../Common/ModalLayout';
import SeoMeta from '../../Common/SeoMeta';

const LamborghiniRepair = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { left, top, width, height } = currentTarget.getBoundingClientRect();
        const x = ((clientX - left) / width - 2) * 20;
        const y = ((clientY - top) / height - 1) * 20;
        const bgX = ((clientX - left) / width - 5) * 30;
        const bgY = ((clientY - top) / height - 0.5) * 30;
        setPosition({ x, y, bgX, bgY });
    };
    UseScrollReveal()
    // 
    const [openBookAppointment, setOpenBookAppointment] = useState(false);
    const handleBookAppointment = () => {
        setOpenBookAppointment(true);
        document.body.classList.add('body-overflow');
    }
    const closeBookAppointment = () => {
        setOpenBookAppointment(false)
        document.body.classList.remove('body-overflow');
    }
    return (
        <>
            <SeoMeta
                title="Lamborghini Service & Repair in Tampa, FL | EEC"
                description="Looking for Lamborghini repair services in Tampa? European Exotic Center can help with everything from oil changes to exhaust repair."
                keywords=""
                ogTitle="Lamborghini Service & Repair in Tampa, FL | EEC"
                ogDescription="Looking for Lamborghini repair services in Tampa? European Exotic Center can help with everything from oil changes to exhaust repair."
            />
            <section className="common-banner-wrap repair-banner">
                <img src={getImages('services/lamborghini-repair-hero.jpg')} alt='lamborghini' />
                <div className="container">
                    <div className='common-banner-pos pt-140 text-center'>
                        <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>Lamborghini Service</h1>
                        <div className='md-title font-2em fw-400 text-center mt-3 mb-4 wow reveal fadeInUp'>in the Tampa Bay Area</div>
                        <div className='my-4 wow reveal fadeInUp'>
                            <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase' onClick={handleBookAppointment}>Schedule Service</button>
                        </div>
                    </div>
                </div>
            </section>
            <section className='exotic-car-wrap'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-12 wow reveal fadeInLeft'>
                            <div className='md-title fw-700 text-uppercase mb-md-5 mb-3'>Lamborghini Service in Tampa, FL</div>
                            <div className='common-text pb-3'>
                                <p>There is no experience quite like owning and driving luxury vehicles like an Aston Martin, Maserati, or Lamborghini. At European Exotic Center, we know just how special these cars are. That is why we only hire the best for our service department, so that we can offer a level of expertise and care that is tough to match.</p>
                            </div>
                            <div className='mt-5 wow reveal fadeInUp d-none d-md-block'>
                                <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase' onClick={handleBookAppointment}>Schedule Service</button>
                            </div>
                        </div>
                        {/* <div className='col-md-6 text-end wow reveal fadeInRight mt-md-0 mt-4'>
                            <img src={getImages('bitmap-copy-2.png')} alt='' />
                        </div> */}
                    </div>
                </div>
            </section>
            <section className='maintenance-services-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6 pe-5 pt-2 wow reveal fadeInLeft'>
                            <div className='sm-title text-uppercase font-2-5em mb-md-4 mb-3'>Auto Services and Repairs We Offer</div>
                            <div className='common-text'>
                                <p>Whether it's a Lamborghini Huracan or Miura, European Exotic Center services all Lamborghini models. We strive to deliver the most one-on-one and transparent experience with each and every client. We know how much you cherish your Lamborghini, so we aim for nothing but the upmost care and precision when servicing your vehicle.</p>
                                <p>We offer a wide variety of car repair and maintenance services, including:</p>
                            </div>
                        </div>
                        <div className='col-md-6 wow reveal fadeInRight mt-md-0 mt-5'>
                            <ul className='oe-list-flex'>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Annual Services, including major services</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>LaRA & Odis Scan Tool</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Clutch replacements including clutch readings</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>AC System diagnostics and repair</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Super Capacitor battery replacements</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>And many more services!</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className='col-12 wow reveal fadeInUp mt-md-5 mt-4 pt-2'>
                            <div className='sm-title text-uppercase font-2-5em mb-4'>Why Choose Us for Lamborghini Auto Repairs?</div>
                            <div className='common-text'>
                                <p>Not just any repair shop can properly care for the variety of exotic cars on the streets today. European Exotic Center is not just any repair shop, though. Our mechanics know these special cars inside and out, so our customers can trust us to handle their vehicles with the care they deserve.</p>
                                <p>We pride ourselves on being a family-owned dealership. We have been in the business for over ten years in and around Tampa, Florida, including nearby locations like Sarasota, Miami and Orlando. We also are proud to be one of the only factory-authorized Koenigsegg service centers in the Southeast United States.</p>
                                <p>Not only do we care for your vehicle, we're competitively priced. Our Lamborghini services are sometimes half the cost of nearby dealerships, who frankly aren't as good as we are. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='book-appointment-wrap dtl-book-appoint-wrap'>
                <div className="mouse-container"
                    onMouseMove={handleMouseMove}>
                    <motion.div
                        className="mouse-background"
                        style={{
                            background: `url(${getImages('ferrari-schedule-bg.webp')}) no-repeat center/cover`
                        }}
                        animate={{
                            x: position.bgX,
                            y: position.bgY,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    />

                    <div className='w-100 text-center mouse-text'>
                        <div className='container'>
                            <div className='banner-lg-title font-3-5em text-uppercase wow reveal fadeInUp'>schedule an appointment</div>
                            <div className='sm-title font-1-2em mt-3 wow reveal fadeInUp'>We would love to work with you and have the opportunity to service your unique vehicle.</div>
                            <div className="my-4 wow reveal fadeInUp">
                                <button type="button" className="orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase" onClick={handleBookAppointment}>Schedule Service</button>
                            </div>
                            <div className='text-center wow reveal fadeInUp'>
                                <a href='tel:8135880905' className='sm-title font-1-5em fw-400 avenir-next text-white'>
                                    Or Call (813) 588-0905
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='fs-schedule-services-wrap'>
                <div className='container'>
                    <div className='banner-lg-title font-2-5em mb-md-4 mb-3 pb-md-2 text-uppercase wow reveal fadeInUp'>Schedule Service in Tampa, FL</div>
                    <div className='sm-title font-1-2em wow reveal fadeInUp'>It’s easy to schedule a service appointment at European Exotic Center. We know our customers lead busy lives, which is why we make it a priority to make the service experience as convenient as possible. Lamborghini owners can make an appointment to take their vehicle in for service, just give us a call at (813) 680-2391.</div>
                </div>
            </section>
            {openBookAppointment &&
                <ModalLayout open={openBookAppointment} close={closeBookAppointment} darkThemeCls='true' modalWidth={1030}>
                    <BookAppointmentModal close={closeBookAppointment} />
                </ModalLayout>
            }
        </>
    )
}
export default LamborghiniRepair
